import { ToastUtils } from '@forgeglobal/design-framework';
import { useOktaAuth } from '@okta/okta-react';
import { Account } from '@tcs/client-portal-api/types/Account';
import Beneficiaries from '@tcs/client-portal-api/types/Beneficiaries';
import { getConfig } from '@tcs/client-portal/config/configService';
import axios from 'axios';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { NotificationContext } from '../providers/NotificationProvider';

export const useBeneficiariesMutation = (accountNumber: string) => {
  const queryClient = useQueryClient();
  const { oktaAuth } = useOktaAuth();
  const { clearNotification } = useContext(NotificationContext);

  return useMutation(
    async (formData: Beneficiaries) => {
      const config = getConfig();
      const tokens = await oktaAuth.tokenManager.getTokens();
      const token = tokens.accessToken?.accessToken;
      return axios.post(
        `${config.API_BASE_URL}/accounts/${accountNumber}/beneficiaries`,
        formData,
        {
          headers: {
            'Content-Type': `application/json`,
            'x-tcs-authorization': token,
          },
        }
      );
    },
    {
      onError: () => {
        ToastUtils.error(
          `Failed to save Beneficiary information. If errors persist, contact support.`,
          true
        );
      },
      onSuccess: () => {
        const previousAccounts: Account[] =
          queryClient.getQueryData(`/accounts`);

        if (previousAccounts == undefined) {
          // previousAccounts is null in the case of an admin account edit
          if (accountNumber) {
            clearNotification('beneficiary', accountNumber);
            queryClient.invalidateQueries(`/accounts`);
            queryClient.invalidateQueries(`/accounts/${accountNumber}`);
            queryClient.invalidateQueries(
              `/accounts/${accountNumber}/clientMaritalStatus`
            );
          }
        } else {
          previousAccounts?.forEach((account) => {
            clearNotification('beneficiary', account.accountNumber);
          });

          previousAccounts?.forEach((account) => {
            queryClient.invalidateQueries(`/accounts`);
            queryClient.invalidateQueries(`/accounts/${account.accountNumber}`);
            queryClient.invalidateQueries(
              `/accounts/${account.accountNumber}/clientMaritalStatus`
            );
          });
        }

        ToastUtils.success(`Beneficiary information has been saved.`, true);
      },
    }
  );
};

export default useBeneficiariesMutation;
